import { Flex } from 'antd'
import { planData } from './data'
import PlanCard from './plan-card'

const StepOne = () => {
  const planCards = planData.map((plan) => (
    <PlanCard key={plan.id} plan={plan} />
  ))

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        marginTop: 42,
        marginBottom: 30,
      }}
    >
      {planCards}
    </div>
  )
}

export default StepOne
